export default __webpack_public_path__ + "727f77c868baf9ac3a93b604b86aa01d.png";